module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-9329248a2718465062ca2958f6166b5e.webp";